<app-menu></app-menu>

<ng-container *ngIf="tenantId; else emptyState">
  <section class="controlmentor-page">
    <header class="hero-card">
      <div>
        <p>Programas de mentoria</p>
        <h1>ControlMentor</h1>
        <p>
          Organize mentorias corporativas, acompanhe mentorados e conecte entregas com o calendário e tarefas do
          ControlTask.
        </p>
        <ul class="pillars">
          <li>Cadastro e gestão</li>
          <li>Aplicação mentor x mentorado</li>
          <li>Perfil completo</li>
          <li>Agenda e tasks</li>
        </ul>
      </div>
      <button class="btn primary" type="button" (click)="programBoard.scrollIntoView({ behavior: 'smooth' })">
        Novo programa
      </button>
    </header>

    <section class="summary-grid" *ngIf="dashboard">
      <article class="summary-card">
        <span>Programas ativos</span>
        <strong>{{ dashboard.activePrograms }}</strong>
      </article>
      <article class="summary-card">
        <span>Mentorados acompanhados</span>
        <strong>{{ dashboard.activeEnrollments }}</strong>
      </article>
      <article class="summary-card">
        <span>Progresso médio</span>
        <strong>{{ dashboard.avgProgress }}%</strong>
      </article>
      <article class="summary-card">
        <span>Agenda (7 dias)</span>
        <strong>{{ dashboard.agendaThisWeek }}</strong>
      </article>
    </section>

    <div class="filter-row">
      <label>
        <span>Filtrar mentorado por CPF</span>
        <input
          type="text"
          placeholder="Digite o CPF"
          [(ngModel)]="mentoradoCpfFilter"
          (ngModelChange)="onCpfFilterChange($event)"
          [ngModelOptions]="{ standalone: true }">
      </label>
      <p>Use qualquer sequência numérica do CPF para visualizar apenas um mentorado em toda a página.</p>
    </div>

    <div class="mentor-layout">
      <section class="card programs-panel" #programBoard>
        <header>
          <div>
            <h2>Painel de mentorias</h2>
            <p>Gerencie os programas cadastrados e seus estágios.</p>
          </div>
        </header>
        <div class="program-list" *ngIf="programs.length; else noProgram">
          <article
            *ngFor="let program of programs; trackBy: trackById"
            (click)="openProgramEdit(program)"
            [class.active]="selectedProgram?.id === program.id">
            <div>
              <h3>{{ program.name }}</h3>
              <small>{{ program.description || 'Sem descrição' }}</small>
            </div>
            <div class="program-meta">
              <span class="pill" [ngClass]="programStatusClass(program.status)">{{ program.status }}</span>
              <span>{{ program.delivery_type }}</span>
            </div>
          </article>
        </div>

        <form class="program-form" [formGroup]="programForm" (ngSubmit)="createProgram()">
          <h3>Criar / editar programa</h3>
          <div class="form-grid">
            <label>Nome
              <input type="text" formControlName="name" placeholder="Ex: Mentor Growth">
            </label>
            <label>Website
              <input type="url" formControlName="website" placeholder="https://controlps.com/mentor">
            </label>
            <label>Formato
              <select formControlName="format">
                <option *ngFor="let format of formatOptions" [value]="format.value">{{ format.label }}</option>
              </select>
            </label>
            <label>Entrega
              <select formControlName="delivery_type">
                <option *ngFor="let option of deliveryTypeOptions" [value]="option.value">{{ option.label }}</option>
              </select>
            </label>
            <label>Status
              <select formControlName="status">
                <option *ngFor="let status of programStatusOptions" [value]="status">{{ status }}</option>
              </select>
            </label>
          </div>
          <label>Descrição
            <textarea formControlName="description" rows="2" placeholder="Resumo, público, materiais..."></textarea>
          </label>
          <button class="btn primary" type="submit">Salvar programa</button>
        </form>
      </section>

      <section class="card applications-panel">
        <header>
          <div>
            <h2>Aplicação da mentoria</h2>
            <p>Mentores, status e progresso dos mentorados.</p>
          </div>
          <div class="applications-toolbar">
            <div class="scope-toggle">
              <button type="button" [class.active]="showAllEnrollments" (click)="setEnrollmentScope('all')">
                Todos programas
              </button>
              <button type="button" [class.active]="!showAllEnrollments" (click)="setEnrollmentScope('program')">
                Programa selecionado
              </button>
            </div>
            <span class="enrollment-count">{{ filteredEnrollments.length }} mentorado(s)</span>
          </div>
        </header>
        <div class="enrollment-board" *ngIf="filteredEnrollments.length; else emptyEnrollments">
          <article
            *ngFor="let enrollment of filteredEnrollments; trackBy: trackById"
            [class.active]="selectedEnrollment?.id === enrollment.id"
            (click)="selectEnrollment(enrollment)">
            <div class="progress-circle" [style.--progress]="progressForEnrollment(enrollment)">
              <span>{{ progressForEnrollment(enrollment) }}%</span>
            </div>
            <div class="enrollment-info">
              <strong (click)="openProfileModal(enrollment)">{{ enrollment.mentorado_snapshot.name }}</strong>
              <small>Mentor: {{ mentorNameFor(enrollment) }}</small>
              <small class="program-name">Programa: {{ programNameFor(enrollment) }}</small>
              <small class="sessions-info">
                {{ completedSessions(enrollment) }}/{{ enrollment.session_count || 0 }} sessões ·
                Próxima: {{ nextSessionDate(enrollment) }}
              </small>
              <span class="pill" [ngClass]="statusChipClass(enrollment.status)">{{ translateEnrollmentStatus(enrollment.status) }}</span>
            </div>
            <div class="enrollment-actions">
              <select
                class="status-select"
                [value]="enrollment.status"
                (change)="changeEnrollmentStatus(enrollment, $any($event.target).value)">
                <option *ngFor="let option of enrollmentStatusOptions" [value]="option.value">{{ option.label }}</option>
              </select>
              <button
                class="btn ghost danger small"
                type="button"
                (click)="confirmSessionsDeletion(enrollment, $event)"
                [disabled]="deletingSessionsId === enrollment.id">
                {{ deletingSessionsId === enrollment.id ? 'Removendo...' : 'Excluir sessões' }}
              </button>
            </div>
          </article>
        </div>
        <ng-template #emptyEnrollments>
          <p class="empty">Nenhum mentorado vinculado a este programa.</p>
        </ng-template>

        <form class="enrollment-form" [formGroup]="enrollmentForm" (ngSubmit)="createEnrollment()">
          <h3>Nova inscrição</h3>
          <div class="form-grid">
            <label>Programa
              <select formControlName="mentoring_program_id">
                <option value="">Selecione</option>
                <option *ngFor="let program of programs" [value]="program.id">{{ program.name }}</option>
              </select>
            </label>
            <label>Mentor responsável
              <select formControlName="mentor_id">
                <option value="">Selecione</option>
                <option *ngFor="let mentor of mentorOptions" [value]="mentor.id">{{ mentor.name }} · {{ mentor.expertise }}</option>
              </select>
            </label>
          </div>
          <div class="form-grid">
            <label>Nome do mentorado
              <input type="text" formControlName="mentorado_name">
            </label>
            <label>Email
              <input type="email" formControlName="mentorado_email">
            </label>
            <label>CPF
              <input type="text" formControlName="mentorado_cpf" placeholder="000.000.000-00">
            </label>
            <label>Quantidade de sessões
              <input type="number" formControlName="session_count" min="0" placeholder="Ex: 12">
            </label>
          </div>
          <button class="btn ghost" type="submit">Adicionar mentorado</button>
        </form>
      </section>

    </div>
  </section>
</ng-container>

<ng-template #noProgram>
  <p class="empty">Nenhuma mentoria cadastrada. Utilize o formulário abaixo.</p>
</ng-template>

<ng-template #emptyState>
  <section class="empty-state">
    <p>Faça login para acessar o ControlMentor.</p>
  </section>
</ng-template>

<div class="program-modal-backdrop" *ngIf="programEditModalOpen" (click)="closeProgramEdit()">
  <section class="program-modal" (click)="$event.stopPropagation()">
    <header>
      <div>
        <h3>Editar programa</h3>
        <p>{{ editingProgram?.name }}</p>
      </div>
      <button type="button" class="close" (click)="closeProgramEdit()">&times;</button>
    </header>
    <form [formGroup]="programEditForm" (ngSubmit)="submitProgramEdit()">
      <label>Nome
        <input type="text" formControlName="name" placeholder="Ex: Programa Scale Up">
      </label>
      <label>Website
        <input type="url" formControlName="website" placeholder="https://controlps.com/mentor">
      </label>
      <div class="form-grid">
        <label>Formato
          <select formControlName="format">
            <option *ngFor="let format of formatOptions" [value]="format.value">{{ format.label }}</option>
          </select>
        </label>
        <label>Entrega
          <select formControlName="delivery_type">
            <option *ngFor="let option of deliveryTypeOptions" [value]="option.value">{{ option.label }}</option>
          </select>
        </label>
        <label>Status
          <select formControlName="status">
            <option *ngFor="let status of programStatusOptions" [value]="status">{{ status }}</option>
          </select>
        </label>
      </div>
      <label>Descrição
        <textarea rows="3" formControlName="description" placeholder="Atualize o resumo do programa"></textarea>
      </label>
      <div class="modal-actions">
        <button type="button" class="btn ghost" (click)="closeProgramEdit()">Cancelar</button>
        <button type="submit" class="btn primary">Salvar alterações</button>
      </div>
    </form>
  </section>
</div>

<div class="agenda-modal-backdrop" *ngIf="agendaModalOpen" (click)="closeAgendaModal()">
  <section class="agenda-modal" (click)="$event.stopPropagation()">
    <header>
      <div>
        <h3>Acompanhamento de mentoria</h3>
        <p>{{ selectedEnrollment?.mentorado_snapshot?.name }} · {{ selectedEnrollment ? mentorNameFor(selectedEnrollment) : '—' }}</p>
      </div>
      <div class="modal-actions">
        <button
          type="button"
          class="btn ghost download-btn"
          (click)="generateMentoringPdf()"
          [disabled]="!selectedEnrollment">
          Baixar PDF
        </button>
        <button type="button" class="close" (click)="closeAgendaModal()">&times;</button>
      </div>
    </header>
    <div class="agenda-modal-tabs">
      <button type="button" [class.active]="activeAgendaTab === 'overview'" (click)="switchAgendaTab('overview')">Painel da sessão</button>
      <button type="button" [class.active]="activeAgendaTab === 'details'" (click)="switchAgendaTab('details')">Detalhes do mentorado</button>
      <button type="button" [class.active]="activeAgendaTab === 'workplan'" (click)="switchAgendaTab('workplan')">Plano de trabalho</button>
      <button type="button" [class.active]="activeAgendaTab === 'history'" (click)="switchAgendaTab('history')">Histórico completo</button>
    </div>
    <div class="agenda-modal-body" *ngIf="activeAgendaTab === 'overview'">
      <div class="session-empty" *ngIf="!hasSessions()">
        <p>Nenhuma sessão foi registrada para este mentorado.</p>
        <button class="btn primary" type="button" (click)="openNewSession()" [disabled]="openingSession">
          {{ openingSession ? 'Abrindo sessão...' : 'Abrir sessão' }}
        </button>
      </div>
      <ng-container *ngIf="hasSessions()">
        <div
          class="session-columns"
          [class.columns-three]="previousSession && currentSession"
          [class.columns-two]="!currentSession || !previousSession">
          <div class="session-block previous session-checkin" *ngIf="previousSession">
            <header>
              <div>
                <h4>Última sessão · #{{ sessionNumber(previousSession) }}</h4>
                <small>{{ formatScheduleDate(previousSession.meeting_date) }}</small>
              </div>
              <span class="today-badge" *ngIf="isTodaySession(previousSession)">Hoje</span>
              <button class="btn ghost" type="button" *ngIf="!currentSession" (click)="reopenSession(previousSession)">
                Reabrir sessão
              </button>
            </header>
            <div class="checkin-progress">
              <span>Progresso atual</span>
              <strong>{{ previousSessionProgress() }}%</strong>
            </div>
            <div class="task-stats" *ngIf="previousSessionTasks.length">
              <strong>{{ completedTaskCount(previousSessionTasks) }}/{{ previousSessionTasks.length }}</strong>
              <span>Conclusão das tarefas da última agenda ({{ taskCompletionPercent(previousSessionTasks) }}%)</span>
            </div>
            <ul class="task-list" *ngIf="previousSessionTasks.length; else emptyPreviousTasks">
              <li *ngFor="let task of previousSessionTasks; trackBy: trackById">
                <label class="task-label">
                  <input type="checkbox" [checked]="task.status === 'DONE'" (change)="toggleTaskProgress(task)">
                  <span>{{ task.title }}</span>
                </label>
                <small class="task-note">{{ task.notes || 'Sem observações' }}</small>
              </li>
            </ul>
            <ng-template #emptyPreviousTasks>
              <p class="empty">Nenhuma tarefa registrada na última agenda.</p>
            </ng-template>
            <div class="session-observations" *ngIf="notesForSession(previousSession).length">
              <strong>Observações registradas</strong>
              <ul>
                <li *ngFor="let note of notesForSession(previousSession)">{{ note }}</li>
              </ul>
            </div>
            <div class="session-files" *ngIf="previousSessionFiles.length">
              <strong>Anexos registrados</strong>
              <ul>
                <li *ngFor="let file of previousSessionFiles">
                  <a [href]="file.file_url || '#'" target="_blank" rel="noopener noreferrer">{{ file.file_name }}</a>
                  <small>{{ formatDate(file.created_at) }}</small>
                </li>
              </ul>
            </div>
          </div>

          <div class="session-block current current-session" *ngIf="currentSession">
            <header>
              <div>
                <h4>Sessão atual · #{{ sessionNumber(currentSession) }}</h4>
                <small>{{ formatScheduleDate(currentSession.meeting_date) }}</small>
              </div>
              <div class="status-actions">
                <span class="status-pill in-progress">{{ sessionStatusLabel(currentSession.status || 'SCHEDULED') }}</span>
                <button
                  class="btn ghost conclude-btn"
                  type="button"
                  *ngIf="currentSessionView === 'active'"
                  (click)="concludeCurrentSession()">
                  Concluir sessão
                </button>
              </div>
            </header>
            <ng-container [ngSwitch]="currentSessionView">
              <div class="session-preview" *ngSwitchCase="'preview'">
                <p>A sessão está pronta para iniciar.</p>
                <div class="preview-actions">
                  <button class="btn primary" type="button" (click)="openCurrentSession()">Abrir sessão</button>
                  <button class="btn ghost" type="button" (click)="enterRescheduleMode()">Reagendar sessão</button>
                </div>
              </div>
              <form class="session-reschedule" *ngSwitchCase="'reschedule'" [formGroup]="sessionRescheduleForm" (ngSubmit)="rescheduleCurrentSession()">
                <label>Nova data e hora
                  <input type="datetime-local" formControlName="meeting_date">
                </label>
                <div class="schedule-actions">
                  <button class="btn primary" type="submit">Confirmar reagendamento</button>
                  <button class="btn ghost text" type="button" (click)="cancelRescheduleMode()">Cancelar</button>
                </div>
              </form>
              <div class="session-active" *ngSwitchCase="'active'">
                <div class="session-task-panel validation-panel">
                  <div class="task-toggle">
                    <div>
                      <strong>Planejamento de tarefas</strong>
                      <small>{{ currentSessionTasks.length }} tarefas · {{ taskCompletionPercent(currentSessionTasks) }}% concluído</small>
                    </div>
                    <button type="button" class="btn ghost text" (click)="toggleTaskPanel()">
                      {{ taskPanelCollapsed ? 'Expandir' : 'Recolher' }}
                    </button>
                  </div>
                  <div *ngIf="!taskPanelCollapsed">
              <div class="task-header">
                <strong>Validação de tarefas</strong>
              </div>
              <ul class="task-list compact" *ngIf="currentSessionTasks.length; else emptyCurrentTasks">
                <li *ngFor="let task of currentSessionTasks; trackBy: trackById">
                  <div class="task-header-row">
                    <label class="task-label">
                      <input type="checkbox" [checked]="task.status === 'DONE'" (change)="toggleTaskProgress(task)">
                      <span>{{ task.title }}</span>
                    </label>
                    <div class="task-actions">
                      <button type="button" (click)="startTaskEdition(task, $event)">Editar</button>
                      <button type="button" (click)="deleteTask(task, $event)">Excluir</button>
                    </div>
                  </div>
                  <small class="task-note">{{ task.notes || 'Sem observações' }}</small>
                  <a
                    *ngIf="task.attachment_url"
                    class="attachment-link"
                    [href]="task.attachment_url"
                    target="_blank"
                    rel="noopener noreferrer">
                    Abrir anexo
                  </a>
                  <div class="task-edit-form" *ngIf="editingTaskId === task.id">
                    <input
                      type="text"
                      [(ngModel)]="editingTaskTitle"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="Título da tarefa">
                    <textarea
                      rows="2"
                      [(ngModel)]="editingTaskNotes"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="Observações"></textarea>
                    <div class="edit-buttons">
                      <button class="btn primary" type="button" (click)="saveTaskEdition()">Salvar</button>
                      <button class="btn ghost text" type="button" (click)="cancelTaskEdition()">Cancelar</button>
                    </div>
                  </div>
                </li>
              </ul>
                    <ng-template #emptyCurrentTasks>
                      <p class="empty">Nenhuma tarefa cadastrada para esta sessão.</p>
                    </ng-template>
                  </div>
                </div>
                <form class="new-task-form" [formGroup]="currentTaskForm" (ngSubmit)="registerCurrentTask()">
                  <label>Nova tarefa
                    <input type="text" formControlName="title" placeholder="Ex: Revisar entregáveis da squad">
                  </label>
                  <label>Anotações
                    <textarea rows="2" formControlName="notes" placeholder="Contextualize responsáveis ou entregas."></textarea>
                  </label>
                  <button class="btn ghost spaced" type="submit">Adicionar tarefa</button>
                </form>
                <div class="session-observations" *ngIf="notesForSession(currentSession).length">
                  <strong>Observações registradas</strong>
                  <ul>
                    <li *ngFor="let note of notesForSession(currentSession)">{{ note }}</li>
                  </ul>
                </div>
                <form class="session-note-form" [formGroup]="sessionNoteForm" (ngSubmit)="saveSessionObservation()">
                  <label>Observações da sessão
                    <textarea rows="3" formControlName="note" placeholder="Descreva aprendizados ou decisões desta sessão."></textarea>
                  </label>
                  <button class="btn primary" type="submit">Salvar observação</button>
                </form>
                <div class="session-files">
                  <div class="session-files-header">
                    <strong>Anexos da sessão</strong>
                    <span *ngIf="sessionAttachmentLoading" class="uploading">Enviando arquivos...</span>
                  </div>
                  <label class="file-upload-btn clip-only" aria-label="Adicionar anexos">
                    <input type="file" multiple (change)="handleSessionFile($event)">
                    <mat-icon>{{ sessionAttachmentLoading ? 'hourglass_top' : 'attach_file' }}</mat-icon>
                  </label>
                  <ul *ngIf="currentSessionFiles.length; else emptyFiles">
                    <li *ngFor="let file of currentSessionFiles">
                      <a [href]="file.file_url || '#'" target="_blank" rel="noopener noreferrer">{{ file.file_name }}</a>
                      <small>{{ formatDate(file.created_at) }}</small>
                    </li>
                  </ul>
                  <ng-template #emptyFiles>
                    <p class="empty">Nenhum anexo enviado nesta sessão.</p>
                  </ng-template>
                </div>
              </div>
            </ng-container>
          </div>

          <div class="session-block next session-plan">
            <header>
              <div>
                <h4>Próxima sessão</h4>
                <small *ngIf="upcomingSession && !editingUpcomingDate">
                  {{ formatScheduleDate(upcomingSession.meeting_date) }}
                </small>
                <small *ngIf="!upcomingSession || editingUpcomingDate">Agende a próxima sessão</small>
              </div>
              <button
                type="button"
                class="icon-button"
                *ngIf="upcomingSession && !editingUpcomingDate && canScheduleNextSession()"
                (click)="editUpcomingSession()"
                aria-label="Editar data da próxima sessão">
                &#9998;
              </button>
            </header>

            <ng-container *ngIf="canScheduleNextSession(); else lockedScheduling">
              <ng-container *ngIf="!upcomingSession || editingUpcomingDate; else upcomingSummary">
                <form class="inline-schedule" [formGroup]="scheduleForm" (ngSubmit)="scheduleSession()">
                  <label>Data e hora
                    <input type="datetime-local" formControlName="meeting_date">
                  </label>
                  <div class="schedule-actions">
                    <button class="btn ghost" type="submit">
                      {{ upcomingSession ? 'Atualizar agenda' : 'Registrar agenda' }}
                    </button>
                    <button class="btn ghost text" type="button" *ngIf="upcomingSession" (click)="cancelUpcomingEdit()">Cancelar</button>
                  </div>
                </form>
              </ng-container>
            </ng-container>

            <ng-template #lockedScheduling>
              <p class="empty">Inicie a sessão atual para agendar ou reagendar a próxima.</p>
              <ng-container *ngIf="upcomingSession">
                <ng-container *ngTemplateOutlet="upcomingSummary"></ng-container>
              </ng-container>
            </ng-template>

            <ng-template #upcomingSummary>
              <ng-container *ngIf="upcomingSession as summarySession">
                <div class="upcoming-info">
                  <div class="planned-date">
                    <span class="muted-label">Data programada </span>
                    <strong>{{ formatScheduleDate(summarySession.meeting_date) }}</strong>
                  </div>
                  <button class="btn ghost" type="button" (click)="downloadUpcomingSessionPdf()" [disabled]="!upcomingSessionTasks.length">
                    Baixar próxima sessão
                  </button>
                </div>
                <form [formGroup]="agendaTaskForm" (ngSubmit)="registerNextTask()">
                  <label>Nova tarefa
                    <input type="text" formControlName="title" placeholder="Ex: Atualizar plano de ação">
                  </label>
                  <label>Anotações
                    <textarea rows="2" formControlName="notes" placeholder="Contextualize entregáveis ou responsáveis."></textarea>
                  </label>
                  <div class="task-form-actions">
                    <button type="button" class="btn ghost spaced" (click)="triggerAttachmentInput()">Anexo</button>
                    <button type="submit" class="btn ghost spaced">Adicionar tarefa</button>
                  </div>
                  <input hidden type="file" #attachmentInput (change)="handleAgendaAttachment($event)">
                  <div class="attachment-preview" *ngIf="agendaAttachment?.name">
                    <small>Arquivo selecionado: {{ agendaAttachment?.name }}</small>
                  </div>
                </form>
                <ul
                  class="task-list compact"
                  *ngIf="upcomingSessionTasks.length; else emptyUpcomingTasks"
                  cdkDropList
                  [cdkDropListData]="upcomingSessionTasks"
                  (cdkDropListDropped)="reorderUpcomingTasks($event)">
                  <li *ngFor="let task of upcomingSessionTasks; trackBy: trackById" cdkDrag>
                    <div class="task-header-row">
                      <span class="drag-handle" cdkDragHandle>
                        <mat-icon>drag_indicator</mat-icon>
                      </span>
                      <label class="task-label">
                        <input type="checkbox" [checked]="task.status === 'DONE'" (change)="toggleTaskProgress(task)">
                        <span>{{ task.title }}</span>
                      </label>
                      <div class="task-actions">
                        <button type="button" (click)="startTaskEdition(task, $event)">Editar</button>
                        <button type="button" (click)="deleteTask(task, $event)">Excluir</button>
                      </div>
                    </div>
                    <small class="task-note">{{ task.notes || 'Sem observações' }}</small>
                    <a
                      *ngIf="task.attachment_url"
                      class="attachment-link"
                      [href]="task.attachment_url"
                      target="_blank"
                      rel="noopener noreferrer">
                      Abrir anexo
                    </a>
                    <div class="task-edit-form" *ngIf="editingTaskId === task.id">
                      <input
                        type="text"
                        [(ngModel)]="editingTaskTitle"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Título da tarefa">
                      <textarea
                        rows="2"
                        [(ngModel)]="editingTaskNotes"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Observações"></textarea>
                      <div class="edit-buttons">
                        <button class="btn primary" type="button" (click)="saveTaskEdition()">Salvar</button>
                        <button class="btn ghost text" type="button" (click)="cancelTaskEdition()">Cancelar</button>
                      </div>
                    </div>
                  </li>
                </ul>
                <ng-template #emptyUpcomingTasks>
                  <p class="empty">Sem tarefas planejadas para a próxima agenda.</p>
                </ng-template>
              </ng-container>
            </ng-template>
          </div>
        </div>

      </ng-container>
    </div>
    <div class="agenda-modal-body details" *ngIf="activeAgendaTab === 'details'">
      <div class="detail-card-group" *ngIf="!detailsEditMode">
        <div class="detail-card">
          <h4>Perfil do mentorado</h4>
          <div class="detail-grid">
            <div>
              <span>Nome</span>
              <strong>{{ profileForm.value.name || selectedEnrollment?.mentorado_snapshot?.name }}</strong>
            </div>
            <div>
              <span>Email</span>
              <strong>{{ profileForm.value.email || selectedEnrollment?.mentorado_snapshot?.email }}</strong>
            </div>
            <div>
              <span>CPF</span>
              <strong>{{ profileForm.value.cpf || selectedEnrollment?.mentorado_snapshot?.cpf }}</strong>
            </div>
            <div>
              <span>Telefone</span>
              <strong>{{ profileForm.value.phone || '—' }}</strong>
            </div>
            <div>
              <span>Grau de escolaridade</span>
              <p>{{ profileForm.value.education_level || '—' }}</p>
            </div>
            <div>
              <span>Cursos / Certificações</span>
              <div class="tag-display" *ngIf="courseTags.length; else noCourseTags">
                <span class="tag-chip" *ngFor="let tag of courseTags">{{ tag }}</span>
              </div>
              <ng-template #noCourseTags>
                <p>—</p>
              </ng-template>
            </div>
            <div class="full">
              <span>Experiência profissional</span>
              <p>{{ profileForm.value.professional_experience || '—' }}</p>
            </div>
            <div class="full">
              <span>Outras experiências</span>
              <p>{{ profileForm.value.extra_experience || '—' }}</p>
            </div>
            <div>
              <span>Palavras-chave</span>
              <div class="tag-display" *ngIf="keywordTags.length; else noKeywordTags">
                <span class="tag-chip" *ngFor="let tag of keywordTags">{{ tag }}</span>
              </div>
              <ng-template #noKeywordTags>
                <p>—</p>
              </ng-template>
            </div>
          </div>
          <div class="detail-block">
            <span>Objetivo principal</span>
            <p class="multiline">{{ profileForm.value.objective || '—' }}</p>
          </div>
          <div class="detail-block">
            <span>Dores do mentorado</span>
            <p class="multiline">{{ profileForm.value.pains_description || '—' }}</p>
          </div>
          <div class="detail-block">
            <span>Dores (palavras-chave)</span>
            <div class="tag-display" *ngIf="painsTags.length; else noPainsTags">
              <span class="tag-chip" *ngFor="let tag of painsTags">{{ tag }}</span>
            </div>
            <ng-template #noPainsTags>
              <p>—</p>
            </ng-template>
          </div>
          <div class="detail-block">
            <span>Resumo</span>
            <p class="multiline">{{ profileForm.value.profile_description || '—' }}</p>
          </div>
        </div>
        <div class="detail-card">
          <h4>Detalhes do negócio</h4>
          <div class="detail-grid">
            <div>
              <span>Setor</span>
              <strong>{{ businessForm.value.business_sector || '—' }}</strong>
            </div>
            <div>
              <span>Site / LinkedIn</span>
              <strong>{{ businessForm.value.company_website || '—' }}</strong>
            </div>
            <div>
              <span>Cargo</span>
              <strong>{{ businessForm.value.job_title || '—' }}</strong>
            </div>
            <div>
              <span>Descrição do negócio</span>
              <p>{{ businessForm.value.business_description || '—' }}</p>
            </div>
            <div>
              <span>Responsabilidades</span>
              <div class="tag-display" *ngIf="responsibilityTags.length; else noRespTags">
                <span class="tag-chip" *ngFor="let tag of responsibilityTags">{{ tag }}</span>
              </div>
              <ng-template #noRespTags>
                <p>—</p>
              </ng-template>
            </div>
            <div>
              <span>Rotina diária</span>
              <p>{{ businessForm.value.daily_activities || '—' }}</p>
            </div>
            <div>
              <span>Descrição da função</span>
              <p>{{ businessForm.value.role_description || '—' }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="details-actions" *ngIf="!detailsEditMode">
        <div class="details-action-group">
          <button class="btn outline edit-details-btn" type="button" (click)="enterDetailsEdit()">Editar dados</button>
        </div>
      </div>
      <div class="details-edit-grid" *ngIf="detailsEditMode">
        <form [formGroup]="profileForm" class="profile-form">
          <h4>Dados pessoais</h4>
          <label>Nome completo
            <input type="text" formControlName="name">
          </label>
          <label>Email
            <input type="email" formControlName="email">
          </label>
          <label>CPF
            <input type="text" formControlName="cpf" (input)="applyCpfMask($event)">
          </label>
          <label>Telefone
            <input type="text" formControlName="phone" (input)="applyPhoneMask($event)">
          </label>

          <h4>Escolaridade</h4>
          <label>Grau de escolaridade
            <input type="text" formControlName="education_level" list="mentorEducationLevels" placeholder="Selecione ou digite">
          </label>
          <datalist id="mentorEducationLevels">
            <option *ngFor="let level of educationLevelOptions" [value]="level"></option>
          </datalist>
          <label>Cursos / certificações
            <div class="tag-input">
              <span class="tag-chip" *ngFor="let tag of courseTags; let i = index">
                {{ tag }}
                <button type="button" (click)="removeTag('courses', i)">&times;</button>
              </span>
              <input type="text" placeholder="Adicionar e pressionar Enter" (keydown.enter)="addTagFromInput($event, 'courses')">
            </div>
            <input type="hidden" formControlName="courses_taken">
          </label>

          <h4>Experiências profissionais</h4>
          <label class="full-width">Experiência profissional
            <textarea formControlName="professional_experience" rows="3"></textarea>
          </label>
          <label class="full-width">Outras experiências
            <textarea formControlName="extra_experience" rows="2" placeholder="Cursos livres, intercâmbios, voluntariado..."></textarea>
          </label>

          <h4>Objetivo</h4>
          <label class="full-width">Objetivo principal
            <textarea formControlName="objective" rows="3"></textarea>
          </label>

          <h4>Dificuldades / dores</h4>
          <label class="full-width">Dores do mentorado
            <textarea formControlName="pains_description" rows="3"></textarea>
          </label>
          <label>Dores (palavras-chave)
            <div class="tag-input">
              <span class="tag-chip" *ngFor="let tag of painsTags; let i = index">
                {{ tag }}
                <button type="button" (click)="removeTag('pains', i)">&times;</button>
              </span>
              <input type="text" placeholder="Adicionar e pressionar Enter" (keydown.enter)="addTagFromInput($event, 'pains')">
            </div>
            <input type="hidden" formControlName="pains_keywords">
          </label>

          <h4>Palavras-chave</h4>
          <label>Palavras-chave
            <div class="tag-input">
              <span class="tag-chip" *ngFor="let tag of keywordTags; let i = index">
                {{ tag }}
                <button type="button" (click)="removeTag('keywords', i)">&times;</button>
              </span>
              <input type="text" placeholder="Adicionar e pressionar Enter" (keydown.enter)="addTagFromInput($event, 'keywords')">
            </div>
            <input type="hidden" formControlName="objective_keywords">
          </label>

          <h4>Resumo</h4>
          <label class="full-width">Resumo
            <textarea formControlName="profile_description" rows="3"></textarea>
          </label>
        </form>
        <form [formGroup]="businessForm" class="business-form">
          <h4>Detalhes do negócio</h4>
          <div class="business-grid">
            <label>Setor
              <input type="text" formControlName="business_sector" list="mentorBusinessSectors" placeholder="Selecione ou digite">
            </label>
            <label>Site / LinkedIn
              <input type="url" formControlName="company_website">
            </label>
            <label>Cargo
              <input type="text" formControlName="job_title" list="mentorJobRoles" placeholder="Selecione ou digite">
            </label>
            <label class="full-width">Descrição do negócio
              <textarea formControlName="business_description" rows="3"></textarea>
            </label>
            <label class="full-width">Responsabilidades
              <div class="tag-input">
                <span class="tag-chip" *ngFor="let tag of responsibilityTags; let i = index">
                  {{ tag }}
                  <button type="button" (click)="removeTag('responsibilities', i)">&times;</button>
                </span>
                <input type="text" placeholder="Adicionar e pressionar Enter" (keydown.enter)="addTagFromInput($event, 'responsibilities')">
              </div>
              <input type="hidden" formControlName="responsibilities">
            </label>
            <label>Rotina diária
              <textarea formControlName="daily_activities" rows="2"></textarea>
            </label>
            <label>Descrição da função
              <textarea formControlName="role_description" rows="2"></textarea>
            </label>
          </div>
        </form>
        <datalist id="mentorBusinessSectors">
          <option *ngFor="let sector of businessSectorOptions" [value]="sector"></option>
        </datalist>
        <datalist id="mentorJobRoles">
          <option *ngFor="let role of jobRoleOptions" [value]="role"></option>
        </datalist>
      </div>
      <div class="details-actions details-actions--edit" *ngIf="detailsEditMode">
        <div class="details-action-group">
          <button class="btn ghost" type="button" (click)="cancelDetailsEdit()">Cancelar</button>
          <button class="btn primary" type="button" (click)="saveDetailsForms()">Salvar dados</button>
        </div>
      </div>
    </div>
    <div class="agenda-modal-body workplan" *ngIf="activeAgendaTab === 'workplan'">
      <form [formGroup]="profileForm" class="workplan-form" (ngSubmit)="saveWorkPlan()">
        <article class="workplan-card" [class.edit-mode]="workPlanEditMode">
          <div class="workplan-card-header">
            <div>
              <h4>Plano de trabalho</h4>
              <p>Documente direcionamentos estratégicos, metas e acordos estabelecidos com o mentorado.</p>
              <small>Plano vigente</small>
            </div>
          </div>
          <ng-container *ngIf="!workPlanEditMode; else workPlanEditTemplate">
            <div
              class="workplan-display"
              [class.empty]="!(profileForm.value.work_plan?.trim())"
              [innerHTML]="profileForm.value.work_plan || 'Nenhum plano registrado ainda.'">
            </div>
          </ng-container>
          <ng-template #workPlanEditTemplate>
            <div class="editor-toolbar">
              <button type="button" (click)="applyEditorCommand('bold')" aria-label="Negrito"><span>B</span></button>
              <button type="button" (click)="applyEditorCommand('italic')" aria-label="Itálico"><span>I</span></button>
              <button type="button" (click)="applyEditorCommand('underline')" aria-label="Sublinhado"><span>U</span></button>
              <button type="button" (click)="applyEditorCommand('insertUnorderedList')" aria-label="Lista não ordenada">• Lista</button>
              <button type="button" (click)="applyEditorCommand('insertOrderedList')" aria-label="Lista ordenada">1. Lista</button>
              <button type="button" (click)="insertEmoji('✅')" aria-label="Adicionar emoji">✅</button>
              <button type="button" (click)="insertEmoji('🔥')" aria-label="Adicionar emoji">🔥</button>
            </div>
            <div
              #workPlanEditor
              class="workplan-editor"
              contenteditable="true"
              (input)="onWorkPlanInput()"
              spellcheck="true">
            </div>
          </ng-template>
        </article>
        <div class="details-actions details-actions--edit workplan-actions">
          <ng-container *ngIf="workPlanEditMode; else viewPlanActions">
            <div class="details-action-group">
              <button class="btn ghost" type="button" (click)="cancelWorkPlanEdit()">Cancelar</button>
              <button class="btn primary" type="submit" [disabled]="savingWorkPlan">
                {{ savingWorkPlan ? 'Salvando...' : 'Salvar plano de trabalho' }}
              </button>
            </div>
          </ng-container>
          <ng-template #viewPlanActions>
            <button class="btn outline" type="button" (click)="enterWorkPlanEdit()">Editar plano de trabalho</button>
          </ng-template>
        </div>
      </form>
    </div>
    <div class="agenda-modal-body history" *ngIf="activeAgendaTab === 'history'">
      <div class="session-history-panel">
        <h4>Histórico de sessões</h4>
        <ul class="session-history-list">
          <li *ngFor="let session of sessionHistory(); trackBy: trackById">
            <div>
              <strong>Sessão #{{ sessionNumber(session) }}</strong>
              <small>{{ formatScheduleDate(session.meeting_date) }}</small>
            </div>
            <span class="status-pill" [ngClass]="session.status.toLowerCase()">{{ sessionStatusLabel(session.status) }}</span>
          </li>
        </ul>
      </div>
      <div class="session-notes full-width">
        <h4>Linha do tempo completa</h4>
        <ul class="timeline compact">
          <li *ngFor="let item of timelineForActiveEnrollment(); trackBy: trackById">
            <span class="dot"></span>
            <div>
              <strong>{{ translateHistoryAction(item.action) }}</strong>
              <small>{{ formatTimelineDate(item.created_at) }}</small>
              <p>{{ item.description || '-' }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</div>
